/**
 * Canonical launch constants. Import from here everywhere — never hardcode
 * a date or time. The `copy-consistency` eval will refuse the build if these
 * values drift out of sync across the codebase.
 */
export const LAUNCH = {
  /** ISO 8601, America/New_York-anchored. Hatch happens at high noon ET. */
  hatchIso: '2026-07-04T12:00:00-04:00',
  hatchDisplayEt: 'Saturday, July 4, 2026 · 12:00 PM ET',
  hatchDisplayShort: 'July 4, 2026 · 12PM ET',
  americaBirthday: "America's 250th Birthday",
  americaHashtag: '#America250',
  freedomHashtag: '#Freedom250',
} as const;

export const ORIGIN_STORY = `Trumpy was laid in a golden nest atop a mountaintop during a July 3rd fireworks show, and hatched at high noon Eastern Time on July 4, 2026 — the exact moment America turned 250. He immediately declared himself "the greatest eagle in the history of eagles, believe me." He has been flapping bigly ever since.`;

/**
 * Whole seconds remaining until the hatch. Never returns negative — after
 * launch it returns 0 so callers don't need special-case logic.
 */
export function secondsUntilHatch(now: Date = new Date()): number {
  const target = new Date(LAUNCH.hatchIso).getTime();
  const diff = Math.floor((target - now.getTime()) / 1000);
  return diff > 0 ? diff : 0;
}
